<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.0582 12.1751H1.45064C0.844188 12.1751 0.333488 11.6644 0.333488 11.0579C0.333488 5.12105 5.15321 0.333244 11.0582 0.333244C11.6646 0.333244 12.1753 0.843944 12.1753 1.4504V11.0579C12.1753 11.6644 11.6646 12.1751 11.0582 12.1751ZM2.63166 9.90887H9.94102V2.59947C6.14269 3.11017 3.11044 6.14246 2.63166 9.90887ZM15.9737 29.6666C8.40893 29.6666 2.28052 23.7935 2.28052 16.548C2.28052 15.8458 2.85506 15.2712 3.55727 15.2712H15.2715V3.55703C15.2715 2.85482 15.846 2.28028 16.5482 2.28028C23.6661 2.28028 29.6668 8.56828 29.6668 15.9734C29.6668 23.5063 23.5065 29.6666 15.9737 29.6666ZM4.9298 17.8247C5.60009 23.0275 10.2921 27.1131 15.9737 27.1131C22.1021 27.1131 27.1133 22.1338 27.1133 15.9734C27.1133 10.3877 22.9958 5.63177 17.825 4.92955V16.548C17.825 17.2502 17.2504 17.8247 16.5482 17.8247H4.9298Z" fill="#00527F"/>
  </svg>
</template>

<script>
  export default {
    name: 'dashboardDash'
  }
</script>
